import type { ScreenSchema } from './types';

const dragSchema: ScreenSchema = {
  template: 'drag',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    // Played on full correct completion
    feedback: { parts: [{ field: 'feedback' }] }
  }
};

export default dragSchema;
